export default __webpack_public_path__ + "9675062b90b8a6336c30694dc9e9b5fb.svg";